import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "./SideMenu";
import Footer from "./Footer";
import Header from "./Header";
import Logout from "./Logout";
import { strings } from "../Utilities/strings";
import Loader from "../Utilities/Loader";
import * as XLSX from "xlsx";
import "@fortawesome/fontawesome-free/css/all.min.css";
// for Sidebar And Navbar
import Search from "../images/search.png";
import { Link } from "react-router-dom";
import Logo from "../images/pioneer-logo.png";
import Menu from "../images/Menu.png";
import CentralLogo from "../images/CentralLogo.png";
import FarmLogo from "../images/FarmLogo.png";
import Tracking from "../images/Tracking.png";
import Notification from "../images/notification.png";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import { useContext } from "react";
import { CategoryContext } from "./CategoryContext";
import Login from "../Login";
import {
  addProduct,
  getCategory,
  getProducts, getMasters,
  getUnitMeasureMaster,
} from "../Utilities/URLCONSTANTS";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import { customstyles, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";
import Add_Icon from "../images/Add_Icon.svg";
import Edit_Icon from "../images/edit_icon.svg";
import searchIcon from "../images/search_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../Utilities/Pagination";

//ProductMaster
const ProductMaster = ({ }) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  //  const  categories = CategoryMaster;
  const [id, setId] = useState("");
  const [productMake, setProductMake] = useState("");
  const [productModel, setProductModel] = useState("");
  const [name, setName] = useState("");
  const [minimumStockShouldBe, setminimumStockShouldBe] = useState("");


  //Product Years
  const [productYearBaseOptions, setProductYearBaseOptions] = useState([])
  const [selectedYear, setSelectedYear] = useState("");
  const [errorProductYearBase, setErrorProductYearBase] = useState("");


  const [categoryID, setCategoryID] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categorydropdowndata, setcategorydropdowndata] = useState([]);
  const [code, setCode] = useState("");
  const [uim, setUim] = useState("");
  const [unitdropdowndata, setunitdropdowndata] = useState([]);
  const [uimName, setUimName] = useState("");
  const [unitCost, setUnitCost] = useState("");
  const [error, setError] = useState("");
  const [status, setStatus] = useState("");
  const [Errorcode, setErrorcode] = useState("");
  const [Errorname, setErrorname] = useState("");
  const [errorProductMake, setErrorProductMake] = useState("");
  const [erorUimCost, setErorUimCost] = useState("");
  const [errorProductModel, setErrorProductModel] = useState("");
  const [errorproductModel, setproductModel] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  const [errorminimumStockShouldBe, setErrorminimumStockShouldBe] =
    useState("");
  const [errorcategoryID, setErrorcategoryID] = useState("");
  const [erroruim, setErroruim] = useState("");
  const [statusArray, setStatusArray] = useState([
    { value: "", name: "Select Status" },
    { value: "1", name: "Active" },
    { value: "0", name: "In-Active" },
  ]);

  const [buttonText, setButtonText] = useState("Submit");
  //const [sno, setSno] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState(
    "Do you want to close Product Mater"
  );
  // const { session, setSession } = useSession();
  const [showMsg, setShowMsg] = useState("false");
  ///modal popup
  const [showModal, setShowModal] = useState(false);

  const [modalData, setModalData] = useState({
    id: "",
    categoryID: "",
    code: "",
    name: "",
    uim: "",
    unitCost: "",
    minimumStockShouldBe: "",
    status: "",
    productModel: "",
    productMake: "",
    selectedYear: "",
  });

  const [data, setData] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const handleCancel_new = () => {

    setShowModal(true);
    setShowPopup(true);
  };
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) =>
          item.productCode && item.productCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.productCategoryName
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.productMake.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.year.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.productModel.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.uim.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.unitCost
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.minimumStockShouldBe
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
      setFilteredData(filteredResults);
      handlePageClick(1)
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  const pageNumbers = [];
  //
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };
  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "Product Code",
        "Name",
        "Product Make",
        "Product Model",
        "Product Category Name",
        "Uim Name",
        "Unit Cost",
        "Minimum StockShouldBe",
        "Product Year",
        "Status",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item, index) => [
        // item.id,
        index + 1,
        item.productCode,
        item.name,
        item.productMake,
        item.productModel,
        item.productCategoryName,
        item.uim,
        item.unitCost,
        item.minimumStockShouldBe,
        item.year,
        item.status === "1" ? "Active" : "InActive",
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Product Master");

    // Save the file
    XLSX.writeFile(wb, "ProductMaster.xlsx");
  };

  const handleCancel = () => {
    //no
    // alert("handleCancel");
    setShowModal(true);
    setShowPopup(false);
  };
  const handleClose = () => {
    //yes
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };

  // ...more items
  const handleNameChange = (e) => {
    const input = e.target.value;
    const result = input.replace(/[^a-z_\s]/gi, "")
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    setName(result);
    if (input) {
      setErrorname("");
    }
  };

  const handleproductMakeChange = (e) => {
    const input = e.target.value;
    const result = input.replace(/[^a-z_\s]/gi, "");
    setProductMake(result);
    if (result) {
      setErrorProductMake("");
    }
  };
  const handleproductModelChange = (e) => {
    const input = e.target.value;
    const result = input.replace(/[^a-z_\s]/gi, "");
    setProductModel(result);
    if (result) {
      setErrorProductModel("");
    }
  };
  const handleCodeChange = (e) => {
    const inputCode = e.target.value;
    setCode(inputCode);
    if (inputCode) {
      setErrorcode("");
    }
  };
  const handleCategoryIdChange = (e) => {
    const inputCategory = e.target.value.replace(/\D/g, "");
    setCategoryID(inputCategory);
    if (inputCategory) {
      setErrorcategoryID("");
    }
  };


  const handleUimChange = (e) => {
    setUim(e.target.value);
    if (e.target.value) {
      setErroruim("");
    }
  };

  const handleunitCostChange = (e) => {
    const inputunitCost = e.target.value;
    // Check if the input is a valid number and not negative
    if (/^\d*$/.test(inputunitCost)) {
      setUnitCost(inputunitCost);
      setErorUimCost(""); // Clear error message if valid
    } else {
      setErorUimCost("Not Allowed Negative Numbers "); // Set error for invalid input
    }
  };


  const handleStatus = (e) => {
    const inputuim = e.target.value;
    if (!isNaN(inputuim)) {
      setStatus(inputuim);
    }
    if (inputuim) {
      setErrorStatus("");
    }
  };


  const handleminimumStockShouldBeChange = (e) => {
    // Allow only numeric values
    const inputValue = e.target.value.replace(/\D/g, ""); // This will remove any non-digit characters
    setminimumStockShouldBe(inputValue);

    // Clear the error if the value is valid (i.e., it's not empty)
    if (inputValue) {
      setErrorminimumStockShouldBe("");
    }
  };

  const handleProductYearChange = (e) => {
    const selectedYearValue = e.target.value;
    setSelectedYear(selectedYearValue);
    setErrorProductYearBase("");
    console.log("Selected Year:", selectedYearValue);
  }

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleSubmit = async (modalData) => {
    if (code === "") {
      setErrorcode("Please Enter  Code");
    }
    if (name === "") {
      setErrorname("Please Enter aName");
    }
    if (productMake === "") {
      setErrorProductMake("Please Enter  Product Make");
    }
    if (productModel === "") {
      setErrorProductModel("Please Enter  Product Model");
    }
    if (minimumStockShouldBe === "") {
      setErrorminimumStockShouldBe("Please Enter  Minimum Stock ");
    }
    if (categoryID === "") {
      setErrorcategoryID("Please Select category Name");
    }
    if (uim === "") {
      setErroruim("Please Select UIM");
    }
    if (selectedYear === "") {
      setErrorProductYearBase("Please Select Product-Year");
    }
    if (unitCost === "") {
      setErorUimCost("Please Enter Unit Cost");
    }
    if (status === "") {
      setErrorStatus("Please Select status");
    }
    try {
      console.log(JSON.stringify(modalData));
      // Destructure the properties from the item object

      // Check if required fields are not empty
      if (
        code !== "" &&
        name !== "" &&
        productMake !== "" &&
        productModel !== "" &&
        minimumStockShouldBe !== "" &&
        selectedYear !== "" &&
        categoryID !== "" &&
        uim !== "" &&
        status !== ""
      ) {
        const apiUrl = addProduct;
        const headers = await GetApiHeaders();
        const dataToSend = {
          Id: { buttonText } == "Submit" ? "" : id.toString(),
          categoryID: categoryID.toString(),
          code: code,
          name: name,
          productMake: productMake,
          productModel: productModel,
          uim: uim.toString(),
          unitCost: unitCost.toString(),
          minimumStockShouldBe: minimumStockShouldBe.toString(),
          year: selectedYear.toString(),
          status: status,
        };

        setIsLoading(true);
        const response = await axios.post(apiUrl, dataToSend, { headers });
        setsubmitResponse(response.data.response);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);

        // Handle the response data as needed
        console.log("Response:", response.data);

        // Proceed with data insertion if the API call was successful
        const newId = String(Date.now());
        const newItem = {
          id: newId,
          categoryID: categoryID,
          code: code,
          name: name,
          productMake: productMake,
          productModel: productModel,
          uim: uim,
          unitCost: unitCost,
          minimumStockShouldBe: minimumStockShouldBe,
          productYear: selectedYear,
          status: status,
        };

        setErrorcode("");
        setErrorname("");
        setproductModel("");
        setErrorProductMake("");
        setproductModel("");
        setErrorStatus("");
        setErrorcategoryID("");
        setErroruim("");
        setErrorProductYearBase("");
        setIsSubmitted(true);
        setData((prevData) => [...prevData, newItem]);
      } else {
        setIsSubmitted(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsSubmitted(false);
    }
  };

  const fetchData = async () => {
    const apiUrl = getProducts;
    const headers = await GetApiHeaders();
    setIsLoading(true);
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("main table response ::;;", JSON.stringify(response));
        setData(response.data.response.ProductMaster);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    // Check if DataTable is already initialized
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      // Destroy the existing DataTable instance
      $(tableRef.current).DataTable().destroy();
    }

    // Initialize the DataTable
    $(tableRef.current).DataTable({
      ordering: false, // Disable sorting
    });
    fetchData();
    fetchCategoryDropdownData();
    fetchUnitDropdownData();
  }, [modalData]);

  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId(0);
    setName("");
    setproductModel("");
    setProductMake("");
    setSelectedYear("");
    setCode("");
    setUim("");
    setUnitCost("");
    setCategoryID("");
    setminimumStockShouldBe("");
    setStatus("");
    setModalData({
      id: "",
      code: "",
      name: "",
      productMake: "",
      productModel: "",
      uim: "",
      unitCost: "",
      minimumStockShouldBe: "",
      selectedYear: "",
      status: "",
    });
  };

  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };

  const fetchUnitDropdownData = async () => {
    const apiUrl = getUnitMeasureMaster;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("responseGetUnitUIM", response);
        setunitdropdowndata(response.data.response.uimMaster);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchCategoryDropdownData = async () => {
    const apiUrl = getCategory;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("responseGetCategory", response);
        setcategorydropdowndata(response.data.response.productCategory);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    getmasters();
  }, []);
  const getmasters = async () => {
    const apiUrl = getMasters;
    const headers = await GetApiHeaders();
    setIsLoading(true);
    axios
      .post(apiUrl, null, { headers })
      .then((response) => {
        setIsLoading(false);
        console.log("responseMake", response);
        setProductYearBaseOptions(response.data.response.productYears);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const updatedItems = (item) => {
    setModalData(item);
    setId(item.id);
    setName(item.name);
    setProductModel(item.productModel);
    setProductMake(item.productMake);
    setminimumStockShouldBe(item.minimumStockShouldBe);
    setCategoryID(item.productCategoryId);
    setCode(item.productCode);
    setUim(item.uim);
    setSelectedYear(item.year);
    setUnitCost(item.unitCost);
    setStatus(item.status);
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(false);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      // Check if values are numeric or decimal
      if (!isNaN(aValue) && !isNaN(bValue)) {
        // Convert to float for proper decimal handling
        const aNumericValue = parseFloat(aValue);
        const bNumericValue = parseFloat(bValue);

        return sortConfig.direction === "asc"
          ? aNumericValue - bNumericValue
          : bNumericValue - aNumericValue;
      }

      // Fallback for string comparison
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };

  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "In Active" },
  ];

  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">Masters</h5>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0 Sub_role_text"> Product Master</h6>
                      </div>
                      <span
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Add Product Master"
                      >
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleModalOpen}
                        >
                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />

                        &nbsp;
                        <label> Entries</label>
                      </div>

                      <div className="d-flex align-items-center">
                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />

                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />

                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <button
                          className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                          onClick={exportToExcel}
                        >
                          Download Excel
                        </button>
                      </div>

                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div className="card-body  ">
                          <div
                            style={{ overflowX: "auto" }}
                          >
                            <Table className="table table-bordered Content_data_table table-striped">
                              <Thead>
                                <Tr>
                                  <Th className="text-center">S.No</Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productCode")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Code
                                      {renderSortIcon("productCode")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("name")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Name
                                      {renderSortIcon("name")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productMake")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Product Make
                                      {renderSortIcon("productMake")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productModel")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Product Model
                                      {renderSortIcon("productModel")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productCategoryName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Category Name
                                      {renderSortIcon("productCategoryName")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("uim")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Unit Measure
                                      {renderSortIcon("uim")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("unitCost")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Unit Cost
                                      {renderSortIcon("unitCost")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("minimumStockShouldBe")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Minimum Stock Should Be
                                      {renderSortIcon("minimumStockShouldBe")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("year")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Product Year
                                      {renderSortIcon("year")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("status")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Status
                                      {renderSortIcon("status")}
                                    </span>
                                  </Th>
                                  <Th className="text-center cursor-pointer">Actions</Th>
                                </Tr>
                              </Thead>

                              <Tbody>
                                {currentItems.length === 0 ? (
                                  <Tr>
                                    <Td
                                      colSpan={19}
                                      className="text-center"
                                      style={{ padding: 195, fontSize: 18 }}
                                    >
                                      Data is not available
                                    </Td>
                                  </Tr>
                                ) : (
                                  currentItems != undefined &&
                                  currentItems != null &&
                                  currentItems.map((item, index) => (
                                    <Tr>
                                      <Td className="text-left">{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                      <Td>{item.productCode}</Td>
                                      <Td>{item.name}</Td>
                                      <Td>{item.productMake}</Td>
                                      <Td>{item.productModel}</Td>
                                      <Td>{item.productCategoryName}</Td>
                                      <Td>{item.uim}</Td>
                                      <Td className="text-right">
                                        {item.unitCost}
                                      </Td>
                                      <Td className="text-right">
                                        {item.minimumStockShouldBe}
                                      </Td>
                                      <Td>{item.year}</Td>
                                      <Td className="text-center">
                                        {item.status === "1" ? (
                                          <span style={{ color: "#4A7729" }}>
                                            Active
                                          </span>
                                        ) : (
                                          <span style={{ color: "#FF0000" }}>
                                            In Active
                                          </span>
                                        )}
                                      </Td>
                                      <Td className="text-center">
                                        <div>
                                          <img
                                            src={Edit_Icon}
                                            alt="Edit Product Master"
                                            title="Edit Product Master"
                                            className="editicon"
                                            onClick={() => updatedItems(item)}
                                          />
                                        </div>
                                      </Td>
                                    </Tr>
                                  ))
                                )}
                              </Tbody>
                              {isLoading && (
                                <Loader
                                  loading={isLoading}
                                  message={"Fetching Data. Please Wait..!"}
                                  loderimage={loaderImage}
                                />
                              )}
                            </Table>
                          </div>
                        </div>
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger  close_btn"
                                onClick={handleCancel_new}
                              >
                                {" "}
                                {/*closeWarning */}X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">
                                  Product Master
                                </span>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Code <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Code"
                                      value={code}
                                      onChange={handleCodeChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {" "}
                                    {Errorcode}{" "}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <label
                                    for="InputName"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Name <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Name"
                                      value={name}
                                      inputMode="text"
                                      onChange={handleNameChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {" "}
                                    {Errorname}{" "}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Product Make{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="Product Make"
                                      value={productMake}
                                      onChange={handleproductMakeChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {" "}
                                    {errorProductMake}{" "}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="InputName"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Product Model{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Product Model"
                                      value={productModel}
                                      inputMode="text"
                                      onChange={handleproductModelChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {" "}
                                    {errorProductModel}{" "}
                                  </span>
                                </div>
                              </div>
                              <div className="row">


                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="categoryID"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Category Name <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={
                                        (Array.isArray(categorydropdowndata)
                                          ? categorydropdowndata
                                          : []
                                        )
                                          .filter((item) => item.status == 1)
                                          .map((item) => ({
                                            value: String(item.productCategoryId),
                                            label: item.name,
                                          }))
                                      }
                                      value={
                                        categoryID
                                          ? (
                                            Array.isArray(categorydropdowndata)
                                              ? categorydropdowndata
                                                .filter((item) => item.status == 1)
                                                .map((item) => ({
                                                  value: String(item.productCategoryId),
                                                  label: item.name,
                                                }))
                                                .find(
                                                  (option) =>
                                                    option.value === String(categoryID)
                                                )
                                              : null
                                          ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleCategoryIdChange({
                                          target: {
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Category Name"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorcategoryID}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="uim"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Unit Measure <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={
                                        (Array.isArray(unitdropdowndata)
                                          ? unitdropdowndata
                                          : []
                                        )
                                          .filter((item) => item.status === "1")
                                          .map((item) => ({
                                            value: item.name,
                                            label: item.name,
                                          }))
                                      }
                                      value={
                                        uim
                                          ? (
                                            Array.isArray(unitdropdowndata)
                                              ? unitdropdowndata
                                                .filter((item) => item.status === "1")
                                                .map((item) => ({
                                                  value: item.name,
                                                  label: item.name,
                                                }))
                                                .find(
                                                  (option) =>
                                                    option.value === String(uim)
                                                )
                                              : null
                                          ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleUimChange({
                                          target: {
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Unit Measure"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {erroruim}
                                  </span>
                                </div>


                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Unit Cost{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="number"
                                      className="form-control p-2"
                                      placeholder="Unit Cost"
                                      value={unitCost}
                                      onChange={handleunitCostChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {" "}
                                    {erorUimCost}{" "}
                                  </span>
                                </div>


                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="productYear"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Product Year <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={productYearBaseOptions.map((item) => ({
                                        value: item.name,
                                        label: item.name,
                                      }))}
                                      value={
                                        selectedYear
                                          ? productYearBaseOptions
                                            .map((item) => ({
                                              value: item.name,
                                              label: item.name,
                                            }))
                                            .find(
                                              (option) =>
                                                option.value === String(selectedYear)
                                            ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleProductYearChange({
                                          target: {
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Product Year"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorProductYearBase}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 ">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-md font-weight-600 mt-1"
                                  >
                                    Minimum Stock ShouldBe{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Minimum Stock ShouldBe"
                                      value={minimumStockShouldBe}
                                      inputMode="text"
                                      onChange={
                                        handleminimumStockShouldBeChange
                                      }
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {" "}
                                    {errorminimumStockShouldBe}{" "}
                                  </span>
                                </div>
                                {error && (
                                  <span
                                    style={{ color: "red" }}
                                    className="error-message"
                                  >
                                    {error}
                                  </span>
                                )}

                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="Input"
                                    class="form-label text-md font-weight-600"
                                  >
                                    Status <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={statusOptions}
                                      value={statusOptions.find(
                                        (option) => option.value === status
                                      )}
                                      onChange={(selectedOption) =>
                                        handleStatus({
                                          target: { value: selectedOption?.value || "" },
                                        })
                                      }
                                      placeholder="Select Status"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />

                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorStatus}
                                  </span>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: "20px"
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="btnn"
                                  onClick={() => {
                                    setModalData({
                                      id: id,
                                      categoryID: categoryID,
                                      code: code,
                                      name: name,
                                      uim: uim,
                                      unitCost: unitCost,
                                      minimumStockShouldBe:
                                        minimumStockShouldBe,
                                      status: status,
                                      productModel: productModel,
                                      productMake: productMake,
                                      year: selectedYear,
                                    });
                                    handleSubmit(modalData);

                                  }}
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>

                                <Button
                                  variant="danger"
                                  className="btnn"
                                  onClick={handleCancel_new}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Product Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Product Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                    {/* Pagination */}
                    <Pagination
                      currentPage={currentPage}
                      totalItems={sortedData.length}
                      itemsPerPage={itemsPerPage}
                      currentItems={currentItems}
                      onPageChange={handlePageClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

        <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
      {/* {!isUserLoggedIn && <Login />} */}
    </body>
  );
};

export default ProductMaster;
